export default {
    //===exemplo de uso:
    //var to = {b:2, d: []};
    //transferValues({a:1, c:{d:3}, e:[4,{f:5}]}, to);
    //console.log(to);
    transferValues(from, to) {
        if (from == undefined || to == undefined)
            return;
            
        let tipo = from.constructor.name;
        if (!['Object','Array'].includes(tipo))
        {
            to = from;
            return;
        }
        
        let keys = Object.keys(from);
        for(var key of keys) {
        
            //console.log('key:', key)
        
            if (from[key] == undefined)
                continue;
        
            tipo = from[key].constructor.name;
            
            if (to[key] == undefined || to[key].constructor.name != tipo)
            {
                //console.log('p1')
                to[key] = from[key];
                continue;
            }
            
            switch (tipo) {
                case 'Array':
                    for(var i in from[key]) {
                        let tipoItem = from[key][i].constructor.name;
                        if (to[key][i] == undefined || to[key][i].constructor.name != tipoItem)
                            to[key][i] = from[key][i];
                        else {
                            //console.log('transfer:', from[key][i], to[key][i])
                            this.transferValues(from[key][i], to[key][i]);
                        }
                    }
                break;
                case 'Object':
                    this.transferValues(from[key], to[key]);
                break;
                default:
                    to[key] = from[key];
                break;
            }
        }
    }
}